import StadiumMaterialuHistoriaList
  from '../model/legislativnyMaterial/StadiumMaterialuHistoriaList';
import { StadiumMaterialuEnum } from '../model/legislativnyMaterial/StadiumMaterialu';
import StadiumMaterialuHistoria from '../model/legislativnyMaterial/StadiumMaterialuHistoria';
import Uuid from '../model/Uuid';

const finalStates = [StadiumMaterialuEnum.VYHLASENE_V_ZBIERKE, StadiumMaterialuEnum.PROCES_UKONCENY];

const getLatestStadium = (historiaRecords: Array<StadiumMaterialuHistoria>): StadiumMaterialuHistoria => {
  const arrayLength = historiaRecords?.length;

  return arrayLength ? historiaRecords[arrayLength - 1] : null;
};

const getLatestRunningStadium = (historiaRecords: Array<StadiumMaterialuHistoria>):
    StadiumMaterialuHistoria => getLatestStadium(historiaRecords?.filter(record => !record?.datumUkoncenia));

const isLatestStadium = (historiaList: StadiumMaterialuHistoriaList, selectedStadium: StadiumMaterialuHistoria)
    : boolean => {
  const stadiumIndex = historiaList?.historiaRecords?.indexOf(selectedStadium);
  return stadiumIndex === historiaList.historiaRecords.length - 1;
};

const getInitialStadium = (historiaList: StadiumMaterialuHistoriaList, stadiumUuid?: Uuid)
    : StadiumMaterialuHistoria => {
  const initialStadium = stadiumUuid
    ? historiaList.historiaRecords.find(stadium => stadium.uuid === stadiumUuid)
    : undefined;

  return initialStadium || historiaList.historiaRecords[historiaList.historiaRecords.length - 1];
};

const isFinalState = (stadium: StadiumMaterialuEnum): boolean => finalStates.includes(stadium);

const isActualStadiumLatestRunning = (stadium: StadiumMaterialuEnum, historiaRecords: Array<StadiumMaterialuHistoria>):
    boolean => {
  const latestRunningStadium = getLatestRunningStadium(historiaRecords);
  return latestRunningStadium && stadium === latestRunningStadium.stadium.hodnota;
};

// eslint-disable-next-line max-len
const currentStadiumEqualsLatest = (currentStadium: StadiumMaterialuEnum, historiaRecords: Array<StadiumMaterialuHistoria>)
    : boolean => {
  const latestStadium = getLatestStadium(historiaRecords);

  return currentStadium === latestStadium?.stadium?.hodnota;
};

export {
  currentStadiumEqualsLatest, getLatestStadium, isActualStadiumLatestRunning,
  isFinalState, isLatestStadium, getInitialStadium,
};
